import React from 'react';
import { Link } from 'react-router-dom';
import image from '../../404.jpg';
const ErrorPage = () => {
    return (
        <div className='min-h-[100vh] bg-white py-6 grid grid-cols-1 gap-y-10 text-center'>
          <h2 className='font-extrabold text-2xl'>Look like you're lost right path</h2>
            <img className='w-8/12 mx-auto h-[400px]' src={image} alt="" />
            <div>
        <Link to='/'  >  <button className="btn bg-blue-800 text-white w-[200px] rounded hover:bg-blue-600">Go Home page</button></Link>
            </div>
        </div>
    );
};

export default ErrorPage;